import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Optional header slot — rendered above the body inside the card frame.
   * For the web context we intentionally do NOT replicate the extension's
   * dark `.ext-header` strip (that's specific to the MV3 popup chrome);
   * pass any node (title, breadcrumb, brand mark, etc.) instead.
   */
  header?: ReactNode;
  children: ReactNode;
}

/**
 * Card — surface container.
 *
 * Web-context equivalent of the prototype's `.ext-panel`: surface bg,
 * 1px border, token radius, soft shadow. Used as the outer frame for
 * view 0 (Login) and most other top-level web screens.
 */
export function Card({ header, children, className, ...rest }: CardProps) {
  const base =
    "bg-surface border border-border rounded-token shadow-sm overflow-hidden";
  const merged = className ? `${base} ${className}` : base;

  return (
    <div {...rest} className={merged}>
      {header !== undefined ? (
        <div className="px-4 py-3 border-b border-border">{header}</div>
      ) : null}
      <div className="p-6">{children}</div>
    </div>
  );
}
